module.exports = __webpack_public_path__ + "img/concrete-hole-decal-02.857982a4.png";